import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRightIcon } from 'lucide-react';
import type { Candidate } from '../types/landing';
type CandidateCardWideProps = {
  candidate: Candidate;
  onOpen: (candidate: Candidate) => void;
};
const tapeTilts = [-4, 3, -2, 5, 2, -5, 4, -3];
export function CandidateCardWide({
  candidate,
  onOpen
}: CandidateCardWideProps) {
  const i = (candidate.order - 1) % tapeTilts.length;
  return <motion.button type="button" onClick={() => onOpen(candidate)} initial="rest" animate="rest" whileHover="hover" whileFocus="hover" variants={{
    rest: {
      y: 0
    },
    hover: {
      y: -8
    }
  }} transition={{
    type: 'spring',
    stiffness: 260,
    damping: 20
  }} aria-label={`Ver perfil de ${candidate.name}`} className="group relative grid h-full w-full grid-cols-1 gap-5 bg-[#FFFEFB] p-3 text-left shadow-[0_1px_2px_rgba(40,30,10,0.08),0_10px_24px_-8px_rgba(40,30,10,0.22)] transition-shadow duration-300 hover:shadow-[0_2px_4px_rgba(40,30,10,0.08),0_24px_44px_-12px_rgba(40,30,10,0.32)] focus:outline-none focus-visible:ring-2 focus-visible:ring-primary sm:grid-cols-[minmax(0,230px)_1fr] sm:p-4" data-id="element-58" data-mp="3rivwqulk4j5q">
      {/* Washi tape */}
      <span aria-hidden className="absolute -top-3 left-10 z-10 h-7 w-24 bg-accent-gold/45 shadow-sm sm:left-[72px]" style={{
      transform: `rotate(${tapeTilts[i]}deg)`,
      clipPath: 'polygon(3% 0, 97% 4%, 100% 50%, 96% 100%, 2% 96%, 0 50%)'
    }} data-id="element-59" data-mp="2476sadgomfam" />

      {/* Photo */}
      <div className="relative aspect-[4/5] w-full overflow-hidden bg-[#EEF1F6]" data-id="element-60" data-mp="1z83qd1w00p6v">
        <motion.img src={candidate.photo} alt={candidate.name} loading="lazy" variants={{
        rest: {
          scale: 1
        },
        hover: {
          scale: 1.06
        }
      }} transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} className="h-full w-full object-cover object-top" data-id="element-61" data-mp="1l8ksr30tcw8t" />
        <span aria-hidden className="pointer-events-none absolute inset-0 shadow-[inset_0_0_0_1px_rgba(0,0,0,0.05)]" data-id="element-62" data-mp="3kjc6w90cgat9" />
      </div>

      {/* Content */}
      <div className="relative flex min-w-0 flex-col px-1 pb-2 sm:py-3 sm:pr-4" data-id="element-63" data-mp="3e4oemrfjhcws">
        <h3 className="type-h4 text-primary" data-id="element-64" data-mp="3e6rdm0yo6gdn">{candidate.name}</h3>

        {candidate.bio && <p className="mt-3 line-clamp-3 text-sm leading-relaxed text-foreground/65" data-id="element-65" data-mp="397515tqo145w">{candidate.bio}</p>}

        <div className="mt-auto pt-5" data-id="element-66" data-mp="5olfxb6emykl">
          <div className="flex items-center gap-3 border-t border-dashed border-foreground/15 pt-4" data-id="element-67" data-mp="5njxgln279su">
            <span className="flex h-20 w-32 shrink-0 items-center justify-center rounded-lg bg-white p-2 ring-1 ring-foreground/10" data-id="element-68" data-mp="qtglw3fka6d">
              <img src={candidate.companyLogo} alt="" loading="lazy" className="max-h-full max-w-full object-contain" data-id="element-69" data-mp="3s237k65042ti" />
            </span>
            <span className="min-w-0 flex-1" data-id="element-70" data-mp="ofmi082tna8d">
              <span className="block text-[10px] font-bold uppercase tracking-[0.14em] text-foreground/45" data-id="element-71" data-mp="oge1ikj59hia">Empresa</span>
              <span className="mt-0.5 block text-[13px] font-semibold leading-snug text-foreground/80" data-id="element-72" data-mp="jmjiljbd56k9">
                {candidate.company}
              </span>
            </span>
            <motion.span variants={{
            rest: {
              x: 0
            },
            hover: {
              x: 3
            }
          }} className="hidden h-10 w-10 shrink-0 items-center justify-center rounded-full bg-primary text-white transition-colors group-hover:bg-secondary-maroon sm:flex" data-id="element-73" data-mp="vyvontjy0utq">
              <ArrowUpRightIcon className="h-4 w-4" data-id="element-74" data-mp="1av382rnj1s7y" />
            </motion.span>
          </div>
        </div>
      </div>
    </motion.button>;
}